window.Zoorix = window.Zoorix || {};
window.Zoorix.config = {showDiscountedPrices: true};


document.addEventListener("zrx-slider-item-added", function (e) {
     var r = r || 1
      , a = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + 0 + "&id=" + e.detail.variantId,
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(t) : Shopify.onItemAdded(t)
        },       
    };
    jQuery.ajax(a)  
});
